<template>
  <div 
    class="container bg-sachlich-white border"
    :class="{ 'flex-grow-1': type === 'last' }"
  >
    <div 
      v-if="!!label || hasIcon"
      class="row pt-2" 
    >
      <div class="col">
        <div class="fw-bold fs-16">
          {{ label }}
        </div>
        <div 
          v-if="!!infoMessage" 
          class="row d-flex align-items-center py-2"
        >
          <div class="col-1 d-flex justify-content-center">
            <Icon 
              type="info" 
              color="sachlich-black"
            />
          </div>
          <div class="col ps-0 lh-base">
            {{ infoMessage }}
          </div>
        </div>
      </div>

      <div 
        v-if="!!hasIcon" 
        class="col-1 d-flex"
      >
        <slot name="icon" />
      </div>
    </div>
  
    <div class="row pt-2 pb-3">
      <div class="col">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useUiStore } from '@/store'
import { mapActions } from 'pinia'
import { defineComponent, PropType } from 'vue'
import Icon from '../common/Icon.vue'

export default defineComponent({
  components: { Icon },
  props: {
    type: { type: String as PropType<'' | 'last'>, default: '' },
    label: { type: String, default: '' },
    infoMessage: { type: String, default: '' },
    hasIcon: { type: Boolean, default: false },
  },
  methods: {
    ...mapActions(useUiStore, {
      hideTooltip: 'hideTooltip',
      showTooltip: 'showTooltip'
    }),
  },
})
</script>
